import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-comment-step',
  templateUrl: './comment-step.component.html',
  styleUrls: ['./comment-step.component.scss']
})
export class CommentStepComponent implements OnInit {
  @Output() nextStepEvent = new EventEmitter();
  @Input() commentForm: FormControl;

  constructor() { }

  ngOnInit(): void {
  }

  nextStep(): void {
    this.nextStepEvent.emit({
      nextStep: 'final-step',
      comment: this.commentForm.value
    });
  }
}
